"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    disableFuture: false,
    disablePast: false,
    format: 'dd/MM/yyyy',
    placeholder: 'DD/MM/YYYY',
    value: undefined,
    onOpen: function () { },
    onClose: function () { },
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map